export default __webpack_public_path__ + "static/media/12.f1976118.jpg";